import { SelectItemModel, SelectValueConstraint } from '@cp/ds/src/components/select/model';
import { CatalogSortingTypes } from 'src/entities/catalog/model/types';

export const SORTING_ITEMS: SelectItemModel<SelectValueConstraint>[] = [
  {
    label: 'Рекомендации YouHelp',
    value: CatalogSortingTypes.Normal,
  },
  {
    label: 'Цена (больше)',
    value: CatalogSortingTypes.PriceDESC,
  },
  {
    label: 'Цена (меньше)',
    value: CatalogSortingTypes.PriceASC,
  },
  {
    label: 'Возраст (больше)',
    value: CatalogSortingTypes.AgeASC,
  },
  {
    label: 'Возраст (меньше)',
    value: CatalogSortingTypes.AgeDESC,
  },
  {
    label: 'Опыт (больше)',
    value: CatalogSortingTypes.ExpDESC,
  },
  {
    label: 'Опыт (меньше)',
    value: CatalogSortingTypes.ExpASC,
  },
  {
    label: 'Отзывы (больше)',
    value: CatalogSortingTypes.ReviewDESC,
  },
  {
    label: 'Отзывы (меньше)',
    value: CatalogSortingTypes.ReviewASC,
  },
];

export const SORTING_ITEMS_VACANCY: SelectItemModel<SelectValueConstraint>[] = [
  {
    label: 'Рекомендации YouHelp',
    value: CatalogSortingTypes.Normal,
  },
  {
    label: 'Возраст (больше)',
    value: CatalogSortingTypes.AgeASC,
  },
  {
    label: 'Возраст (меньше)',
    value: CatalogSortingTypes.AgeDESC,
  },
];
